import { style } from "@vanilla-extract/css";

export const errorContainer = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  padding: "var(--cp-space-8)",
  backgroundColor: "var(--cp-color-background-base)",
  fontFamily: "var(--cp-font-family-default)",
});

export const errorCard = style({
  maxWidth: "480px",
  backgroundColor: "var(--cp-color-background-surface)",
  borderRadius: "var(--cp-border-radius-m)",
  padding: "var(--cp-space-8)",
  border: "var(--cp-border-width-s) solid var(--cp-color-feedback-critical-border)",
});

export const errorHeading = style({
  fontSize: "var(--cp-text-xl-font-size)",
  fontWeight: "var(--cp-font-weight-bold)",
  color: "var(--cp-color-text-primary)",
  marginBottom: "var(--cp-space-3)",
});

export const errorMessage = style({
  fontSize: "var(--cp-text-m-font-size)",
  color: "var(--cp-color-text-secondary)",
  margin: 0,
});
